export const EmailRegularExpression = /^['a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$/;
export const PhoneRegularExpression = /^([(\-\s\.\+]*[0-9][)\-\s\.]*){5,15}$/;

export const HttpHeaders = {
    CSRF_TOKEN: "X-CSRF-TOKEN",
} as const;

export const QueryParameters = {
    LANGUAGE: "language",
    PAGE_SESSION_ID: "vx-psid",
    SESSION_KEY: "vx-skey",
} as const;

export const AdvancedSettingsVersion = "1.0.0";

export const SMALL_WIDTH = 550;
export const MOBILE_WIDTH = 768;
